import {type Module} from 'vuex';
import LocalStorage from '../../../../library/localStorage';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

// state
const state: ModuleSchoolState = {
    entitiesClosed: LocalStorage.get('schoolEntitiesClosed', []),
    search: LocalStorage.get('schoolSearch', {}),
};

// module
const school: Module<ModuleSchoolState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default school;